import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

var sk = {
  language: 'sk',
  country: 'sk',
  name: 'Slovenčina',
  embeddedLocale: merge(error, login),
  flags: ['SK'],
};

export { sk as default };
